// extracted by mini-css-extract-plugin
export var logo = "_lu-2";
export var logoWrapper = "_lu-1";
export var strip = "_lu-0";